/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { StyledText } from "../../../../assets/typography/typography";
import { CircleContainer } from "../../../../components/CircleContainer";
import { UserChallenge } from "../../../../service/api-response/Challenges";
import { colors } from "../../../../components/colors";
import { Progress } from "antd";

const challengeWrapperStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

const infoStyle = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: start;
`;

const subInfoStyle = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const returnChallengeState = (state: string) => {
  switch (state) {
    case "claimed":
      return "Reward claimed";
    case "completed":
      return "Completed and reward awaiting claim";
    default:
      return state.charAt(0).toUpperCase() + state.slice(1);
  }
};

const returnProgressColor = (state: string) => {
  switch (state) {
    case "completed":
    case "claimed":
      return colors.successMedium;
    case "expired":
      return colors.errorMedium;
    default:
      return colors.ctaMain;
  }
};

const returnStateColor = (state: string) => {
  switch (state) {
    case "claimed":
      return colors.ctaInactive;
    case "expired":
      return colors.errorMedium;
    default:
      return colors.successMedium;
  }
};

const returnProgressPercentage = (challenge: UserChallenge) => {
  const progress =
    (challenge.objective_progress / challenge.objective_goal) * 100;
  return Math.round(progress);
};

type Props = {
  challenge: UserChallenge;
};

export const UserChallengeHeader = ({ challenge }: Props) => {
  return (
    <div css={challengeWrapperStyle}>
      <div css={infoStyle}>
        <StyledText
          color={colors.textPrimary}
          className="bodyTextSemibold mb-0"
        >
          {challenge.title}
        </StyledText>
        <div css={subInfoStyle}>
          <CircleContainer
            height="4px"
            width="4px"
            backgroundColor={returnStateColor(challenge.state)}
          />
          <StyledText
            color={colors.textPrimary}
            className="bodySubtextRegular mb-0"
          >
            {returnChallengeState(challenge.state)}
          </StyledText>
        </div>
      </div>
      <Progress
        type="circle"
        strokeColor={returnProgressColor(challenge.state)}
        trailColor={colors.ctaInactive}
        percent={returnProgressPercentage(challenge)}
        size={50}
      />
    </div>
  );
};
